<template>
	<div class="login">
		<div class="login-container">
			<div class="login-image" style="background-image: url(/static/img/ic_login.png)"></div>
			<div class="login-from">
				<h1 class="h1">{{$t('login.account_login')}}</h1>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="0px" class="account-form">
					<el-form-item prop="name">
						<el-input type="text" prefix-icon="el-icon-user-solid fs-18" v-model="ruleForm.name"  @keyup.enter.native="submitForm" auto-complete="off" :placeholder="$t('login.account')"></el-input>
					</el-form-item>
					<el-form-item prop="password">
						<el-input type="text" prefix-icon="el-icon-lock fs-18" v-model="ruleForm.password" @keyup.enter.native="submitForm" show-password auto-complete="off" :placeholder="$t('login.password')"></el-input>
					</el-form-item>
				    <el-button type="primary" class="account-submit"  @click.native.prevent="submitForm" :loading="logining">{{$t('login.logon')}}</el-button>
				</el-form>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	computed: {
		rules(){
			return{
				name: [
					{
						required: true,
						message: this.$t('login.rules_name'),
						trigger: 'blur'
					},
				],
				password: [
					{
						required: true,
						message:this.$t('login.rules_password'),
						trigger: 'blur'
					},
				]
			}
		}
	},
	data() {
		return {
			logining: false,
			ruleForm: {
				name: '',
				password: '',
			},
		};
	},
	// 初始事件
	mounted: function () {
	},
	methods: {
		submitForm(ruleForm) {
			var _this = this;
			this.$refs.ruleForm.validate((valid) => {
				console.log(valid)
				if (valid) {
					var datas = {
						user_name: this.ruleForm.name,
						password: this.ruleForm.password
					};
					var url = "login";
					_this.$post(url, datas).then(res => {
						sessionStorage.setItem('is_co', res.is_co);
						sessionStorage.setItem('TokenId', res.TokenId);
						sessionStorage.setItem('user_name', res.user_name);
						sessionStorage.setItem('have_message', res.have_message);
						_this.$router.push({
							path: '/index'
						});
					}).catch(res => {})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		submitForm_(){
			sessionStorage.setItem('TokenId', '1212121212');
			this.$router.push({
				path: '/parent_index'
			});
		},
	}
}
</script>
<style type="text/css">
.login-container .login-from .account-form .el-input__inner{
	height: 48px;
}
.login-container .login-from .account-form .fs-18{
	font-size: 18px;
}

</style>
<style scoped>
.login{
	width: 100%;
	height: 100vh;
	position: relative;
}
.login-container{
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
	width: 960px;
	display: flex;
}
.login-container .login-image{
	width: 450px;
    height: 452px;
    background-position:center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 4px;
}
.login-container .login-from{
    height: 452px;
    flex: 1;
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;
    text-align: center;
}
.login-container .login-from .h1{
	font-size: 36px;
	color:#333;
	padding-top: 80px;
}
.login-container .login-from .account-form{
	width: 330px;
	margin: 40px auto;
}
.login-container .login-from .account-submit{
	width: 100%;
	height: 50px;
    background: #07f;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue